Model = require("./base_individual_model.coffee")

class CompanyModel extends Model
    model_type: coat.prop("companies")

    constructor: (opts) ->
        if "iframeType" not of opts then opts.iframeType = null

        super opts

    getTrackProps: () ->
        if @loading()
            {
                company_id: @id(),
                error_message: "Model still loading; properties not available"
            }
        else if @requestError()
            {
                company_id: @id(),
                error_message: @requestErrorMessage()
            }
        else
            {
                company_id: @id(),
                company_name: @name(),
                company_short_name: @short_name(),
                company_favorited: @favorited(),
                company_industries: @industries(),
                company_size: @size_display(),
                company_office_locations: @location_values(),
                company_ranking_categories: @ranking_categories(),
                company_tags: @tags()
                company_tag_short_names: @tag_short_names(),
                company_state: @state(),
                # for companies that have twitter widgets
                company_twitter: @twitter(),

                # will be null for non iframe models
                iframe_type: @iframeType()
            }

module.exports = CompanyModel


// WEBPACK FOOTER //
// ./node_modules/musecoreui/models/individual/company_individual_model.coffee